'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

exports.default = function (fields, extra) {
  extra = extra || [];
  var fieldsNames = ['_id'].concat((0, _toConsumableArray3.default)(extra));
  fields.forEach(function (field) {
    fieldsNames.push(field.name);
  });
  var dotFields = (0, _zipObject2.default)(fieldsNames, fieldsNames.map(function (_) {
    return '*';
  }));
  _dotObject2.default.object(dotFields);
  return getStringValue('', dotFields);
};

var _dotObject = require('dot-object');

var _dotObject2 = _interopRequireDefault(_dotObject);

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _zipObject = require('lodash/zipObject');

var _zipObject2 = _interopRequireDefault(_zipObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getStringValue = function getStringValue(key, value) {
  if (value === '*') {
    return key;
  } else {
    var inside = (0, _keys2.default)(value).map(function (key) {
      return getStringValue(key, value[key]);
    }).join('\n');
    return key + ' {\n      ' + inside + '\n    }';
  }
};